export default __webpack_public_path__ + "static/media/Book.dea23c3f.svg";